module.exports = (__webpack_require__(65))("./node_modules/@fortawesome/free-solid-svg-icons/index.es.js");